import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { MenuSearchInput, MenuSearchResponse } from './interfaces/menuSearch'

const getMenuSearchResponseParser = async (response: Response): Promise<MenuSearchResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return response.json() as Promise<MenuSearchResponse>
}

export const menuSearchFetcher = composeFetch(
  composeRequest<MenuSearchInput>(
    setServiceUrl('menuexperience', 1),
    addPath(({ menuId }) => `menu/${menuId}/search`),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(({ query, numPortions, deliveryDate, recipes }) => ({
      numPortions: numPortions.toString(),
      ...(query !== undefined && { query }),
      ...(deliveryDate && { deliveryDate }),
      ...(recipes && { recipes: JSON.stringify(recipes) }),
    })),
  ),
  getMenuSearchResponseParser,
)
